import { initDownloadActions } from '../../js/modules/download.js';
import { accordion } from '../../js/modules/accordion.js';

(function() {
    let pagination_page = 1;
    let form = document.querySelector('[data-filter]');

    let ajaxUrl = php_vars.ajaxUrl;

    function categoryDescriptionAction() {
        let btnOpen = document.querySelector('[data-show-full-description]');
        let btnClose = document.querySelector('[data-show-short-description]');
        let short = document.querySelector('[data-shortDesc]');
        let full = document.querySelector('[data-fullDesc]');

        if (btnOpen ) {
            btnOpen.addEventListener('click', function(e) {
                e.preventDefault();

                if( short ) {
                    short.style.display = 'none';
                }
                if( full ) {
                    full.style.display = 'block';
                }
                btnOpen.style.display = 'none';
                btnClose.style.display = 'block';
            })
        }
        if( btnClose ) {
            btnClose.addEventListener('click', function(e) {
                e.preventDefault();

                if( short ) {
                    short.style.display = 'block';
                }
                if( full ) {
                    full.style.display = 'none';
                }
                btnOpen.style.display = 'block';
                btnClose.style.display = 'none';
            });
        }
    }

    function initFilterButtons() {
        let openFilter = document.querySelector('[data-open-filters]');
        let closeFilter = document.querySelector('[data-close-filters]');
        let filtersContainer = document.querySelector('.filter__form');
        let products_clear = document.querySelector('[data-clear-product-filter]');
        let download_clear = document.querySelector('[data-clear-download-filter]');
        let pagination = document.querySelectorAll('.pagination a');

        openFilter.addEventListener('click', function(e) {
            e.preventDefault();
            filtersContainer.classList.add('active');
        });

        closeFilter.addEventListener('click', function(e) {
            e.preventDefault();
            filtersContainer.classList.remove('active');
        });

        if( products_clear ) {
            products_clear.addEventListener('click', function(e) {
                e.preventDefault();
                clearFilters('product', ['subcategory', 'warranty', 'coatings']);
            });
        }

        if ( download_clear ) {
            download_clear.addEventListener('click', function(e) {
                e.preventDefault();
                clearFilters('download', ['category', 'product_category', 'product_type']);
            });
        }

        if ( pagination ) {
            pagination.forEach(function(item) {
                item.addEventListener('click', function(e) {
                    e.preventDefault();

                    let url_string = item.getAttribute('href');
                    let url = new URL(url_string);
                    let page_no = url.searchParams.get("paged");

                    gsap.to(window, { scrollTo: 0});

                    //CHANGE GLOBAL PAGE NUMBER
                    //AND LAUNCH SEARCH
                    pagination_page = page_no;
                    filterList();


                });
            });
        }
    }

    function initInputHandlers() {
        if( form ) {
            let inputs = form.querySelectorAll('input');
            let type = form.getAttribute('data-filter-object');

            if( inputs.length ) {
                inputs.forEach(function(item) {
                    item.addEventListener('change', function(event) {
                        if( item.getAttribute('name') == 'category' ) {
                            clearSubcategories();
                            clearLevel3Categories()
                        }
                        if (item.getAttribute('name') == 'subcategory' ) {
                            clearLevel3Categories();
                        }

                        filterList();
                        updateUrl();
                    });
                })
            }
        }
    }

    function clearSubcategories() {
        let subcategory_inputs = form.querySelectorAll('[name="subcategory"]:checked');

         if (subcategory_inputs.length ) {
             subcategory_inputs.forEach(function(item) {
                item.checked = false;
            });
        }
    }
    function clearLevel3Categories() {
        let level_3 = form.querySelectorAll('[name="level-3-category"]:checked');

        if (level_3.length ) {
            level_3.forEach(function(item) {
                item.checked = false;
            });
        }
    }


    function filterList() {

        if( form ) {
            let container = document.querySelector('#object-list');
            let filterObject = false;
            var openAll = false;

            switch (form.getAttribute('data-filter-object') ) {
                case 'product':
                    filterObject = getProductFiltersValues();
                    showSubcategory(filterObject.category[0]);
                    showLevel3Category(filterObject.subcategory);
                    break;
                case 'download':
                    filterObject = getDownloadFiltersValues();
                    openAll = filterObject.openAll;
                    break;
            }

            let loader = document.querySelector('.loader');

            jQuery.ajax({
                type : 'post',
                url : ajaxUrl,
                data : filterObject,
                beforeSend: function() {
                    container.innerHTML = '';
                    loader.classList.add('visible');
                },
                error: function( error ) {
                    console.log(error);
                },
                success : function( response ) {
                    loader.classList.remove('visible');
                    container.innerHTML = response;

                    initFilterButtons();
                    categoryDescriptionAction();
                    initDownloadActions();
                    accordion(openAll);
                    changeBreadcrumbsCategory();
                }
            });
        }
    }

    function showSubcategory(id) {
        let active_subcategory = document.querySelector('.filter__subcategorySection.active');

        if( active_subcategory ) {
            active_subcategory.classList.remove('active');
        }
        setTimeout(function() {
            document.querySelector('.filter__subcategorySection[data-id="'+ id +'"]').classList.add('active');
        }, 50);
    }
    function showLevel3Category(subcategories) {

        if (subcategories && subcategories.length == 1 ) {
            let active_level3 = document.querySelector('.filter__level-3-categorySection.active');

            if (active_level3 ) {
                active_level3.classList.remove('active');
            }
            setTimeout(function() {
                document.querySelector('.filter__level-3-categorySection[data-id="' + subcategories[0] +'"]').classList.add('active');
            }, 50);
        } else {
            let active_level3 = document.querySelector('.filter__level-3-categorySection.active');

            if (active_level3 ) {
                active_level3.classList.remove('active');
            }
        }

    }

    function updateUrl() {
        let url = '';
        let basic_slug = form.getAttribute('data-filter-slug');
        let categories = form.querySelector('input[name="category"]:checked');
        let category_url = '';
        let subcategory_slugs = [];
        let subcategories = form.querySelectorAll('input[name="subcategory"]:checked');
        let level_3_categories_slugs = [];
        let level_3_categories = form.querySelectorAll('input[name="level-3-category"]:checked');
        let warranty = form.querySelectorAll('input[name="warranty"]:checked');
        let warranty_slugs = [];
        let coating = form.querySelectorAll('input[name="coatings"]:checked');
        let coating_slugs = [];
        let filecategory = form.querySelectorAll('input[name="filecategory"]:checked');
        let filecategory_slugs = [];
        let productCategory = form.querySelectorAll('input[name="product_category"]:checked');
        let productCategory_slugs = [];

        let filetype = form.querySelectorAll('input[name="product_type"]:checked');
        let filetype_slugs = [];

        if( categories ) {
            category_url = form.querySelector('input[name="category"]:checked').getAttribute('data-slug');
        }

        if( subcategories.length ) {
            subcategories.forEach(function(item) {
                subcategory_slugs.push(item.getAttribute('data-slug'));
            });
        }

        if (level_3_categories.length ) {
            level_3_categories.forEach(function(item) {
                level_3_categories_slugs.push(item.getAttribute('data-slug'));
            });
        }

        if (warranty.length ) {
            warranty.forEach(function(item) {
                warranty_slugs.push(item.getAttribute('data-slug'));
            });
        }

        if (coating.length ) {
            coating.forEach(function(item) {
                coating_slugs.push(item.getAttribute('data-slug'));
            });
        }

        if (filecategory.length ) {
            filecategory.forEach(function(item) {
                filecategory_slugs.push(item.getAttribute('data-slug'));
            });
        }

        if (productCategory.length ) {
            productCategory.forEach(function(item) {
                productCategory_slugs.push(item.getAttribute('data-slug'));
            });
        }

        if (filetype.length ) {
            filetype.forEach(function(item) {
                filetype_slugs.push(item.getAttribute('value'));
            });
        }

        let subcategory_url = subcategory_slugs.toString();
        let level_3_category_url = level_3_categories_slugs.toString();
        let warranty_url = warranty_slugs.toString();
        let coating_url = coating_slugs.toString();
        let filecategory_url = filecategory_slugs.toString();
        let productCategory_url = productCategory_slugs.toString();
        let filetype_url = filetype_slugs.toString();

        url = '/' + basic_slug;

        if ( category_url.length ) {
            url += '/' + category_url + '/';
        }
        let filterCount = 0;

        if( subcategory_url.length > 0 ) {
            url += filterCount == 0 ? '?' : '&';
            url += 'type=' + subcategory_url;
            filterCount++;
        }
        if (level_3_category_url.length > 0 ) {
            url += filterCount == 0 ? '?' : '&';
            url += 'cat=' + level_3_category_url;
            filterCount++;
        }
        if (warranty_url.length > 0 ) {
            url += filterCount == 0 ? '?' : '&';
            url += 'warranty=' + warranty_url;
            filterCount++;
        }
        if (coating_url.length > 0 ) {
            url += filterCount == 0 ? '?' : '&';
            url += 'coat=' + coating_url;
            filterCount++;
        }
        if (filecategory_url.length > 0 ) {
            url += filterCount == 0 ? '?' : '&';
            url += 'filecategory=' + filecategory_url;
            filterCount++;
        }
        if (productCategory_url.length > 0 ) {
            url += filterCount == 0 ? '?' : '&';
            url += 'productcategory=' + productCategory_url;
            filterCount++;
        }
        if (filetype_url.length > 0 ) {
            url += filterCount == 0 ? '?' : '&';
            url += 'filetype=' + filetype_url;
            filterCount++;
        }

        window.history.pushState("", "", url);

    }

    function getProductFiltersValues() {
        let obj = {};
        let category = form.querySelector('[name="category"]:checked') ? form.querySelector('[name="category"]:checked').value : [];
        let subcategory = form.querySelectorAll('[name="subcategory"]:checked');
        let category_level_3 = form.querySelectorAll('[name="level-3-category"]:checked');
        let coatings = form.querySelectorAll('[name="coatings"]:checked');
        let warranty = form.querySelectorAll('[name="warranty"]:checked');
        let language = form.getAttribute('data-language');


        obj.category = [category];
        obj.action = 'filterProductList';

        if( subcategory.length ) {
            let values = [];
            subcategory.forEach(function(item) {
                values.push(item.value);
            });
            obj.subcategory = values;
        }

        if ( category_level_3.length ) {
            let values = [];
            category_level_3.forEach(function(item) {
                values.push(item.value);
            });
            obj.category_level_3 = values;
        }

        if( coatings.length ) {
            let values = [];
            coatings.forEach(function(item) {
                values.push(item.value);
            });
            obj.coatings = values;
        }

        if( warranty.length ) {
            let values = [];
            warranty.forEach(function(item) {
                values.push(item.value);
            });
            obj.warranty = values;
        }
        obj.paged = pagination_page;
        obj.language = language;

        return obj;
    }

    function getDownloadFiltersValues() {
        let obj = {};

        //WE SEND ALL CATEGORIES IF THERE IS NO CATEGORY SELECTED
        //SO WE WILL SHOW EVERY CATEGORY. IT'S BECAUSE OF ACCORDION
        let category = form.querySelectorAll('[name="filecategory"]:checked').length ? form.querySelectorAll('[name="filecategory"]:checked') : form.querySelectorAll('[name="filecategory"]');
        let product_category = form.querySelectorAll('[name="product_category"]:checked');
        let product_type = form.querySelectorAll('[name="product_type"]:checked');
        let language = form.getAttribute('data-language');

        obj.action = 'filterDownloadList';

        if ( category.length ) {
            let values = [];
            category.forEach(function(item) {
                values.push(item.value);
            });
            obj.filecategory = values;
        }

        if ( product_category.length ) {
            let values = [];
            product_category.forEach(function(item) {
                values.push(item.value);
            });
            obj.product_category = values;
        }

        if (product_type.length ) {
            let values = [];
            product_type.forEach(function(item) {
                values.push(item.value);
            });
            obj.product_type = values;
        }


        if (form.querySelectorAll('[name="filecategory"]:checked').length || form.querySelectorAll('[name="product_category"]:checked').length || form.querySelectorAll('[name="product_type"]:checked').length ) {
            obj.openAll = true;
        } else {
            obj.openAll = false;
        }

        obj.language = language;

        return obj;
    }

    function clearFilters(type, filters) {
        if( filters.length ) {
            filters.forEach(function(filter) {
                let activeFilters = form.querySelectorAll('[name="'+ filter +'"]:checked');

                if (activeFilters.length ) {
                    activeFilters.forEach(function(item) {
                        item.checked = false;
                    });
                }
            });

            filterList();
            updateUrl();
        }
    }

    function changeBreadcrumbsCategory() {
        const category = document.querySelector('[data-product-category]');
        const breadcrumb = document.querySelector('.breadcrumbs__current');
        breadcrumb.innerHTML = category.dataset.productCategory;
    }


    window.addEventListener('load', function() {

        filterList();
        initInputHandlers();


    });
}())



//////////////////
// WEBPACK FOOTER
// ./js/modules/filter.js
// module id = 16
// module chunks = 0